import React from "react";
import { Box, Typography, List, Divider, styled } from "@mui/material";
import CartItem from "../CartItem/CartItem";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../app/store";
import {
  cartLineKey,
  removeItemFromCart,
  updateCartItem,
} from "../../services/cartSlice/cartSlice";
import CartTotals from "../CartTotals/CartTotals";

const CartContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const CartContent = styled(Box)(({ theme }) => ({
  width: "100%",
  background: theme.palette.background.default,
  padding: theme.spacing(1),
  borderRadius: theme.spacing(0.5),
  color: theme.palette.common.black,
}));

const Cart: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const cartItems = useSelector((state: RootState) => state.cart.items);

  const itemsSubtotal = useSelector((state: RootState) => state.cart.itemsSubtotal);
  const quoteItemCount = useSelector((state: RootState) => state.cart.quoteItemCount);

  const updateCartQuantity = (key: string, newQuantity: number) => {
    dispatch(updateCartItem({ key, quantity: newQuantity }));
  };

  const removeCartItem = (key: string) => {
    dispatch(removeItemFromCart(key));
  };

  return (
    <CartContainer>
      <CartContent>
        <Typography variant="h6" fontWeight={"bold"}>
          Factura
        </Typography>
        <Typography>
          {"Revisa los artículos en tu carrito y el total antes de proceder al pago."}
        </Typography>

        <List>
          {cartItems.map((item) => (
            <CartItem
              key={cartLineKey(item)}
              item={item}
              updateCartItem={updateCartQuantity}
              removeCartItem={removeCartItem}
            />
          ))}
        </List>
        <Divider sx={{ my: 2 }} />
        <CartTotals itemsSubtotal={itemsSubtotal} quoteItemCount={quoteItemCount} />
      </CartContent>
    </CartContainer>
  );
};

export default Cart;
